import { api, UserOut } from './api';

export type AuthState =
  | { status: 'loading' }
  | { status: 'anonymous' }
  | { status: 'authenticated'; user: UserOut };

export async function loadAuthState(): Promise<AuthState> {
  try {
    const user = await api.getMe();
    return { status: 'authenticated', user };
  } catch {
    return { status: 'anonymous' };
  }
}

export function goToLoginPage(): void {
  globalThis.location.href = '/login';
}

export async function signOut(): Promise<void> {
  await api.logout();
  globalThis.location.href = '/';
}
